import { CuentaSelector } from 'core/cuenta/components/CuentaSelector/CuentaSelector';
import { Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { FormWithValidation } from 'shared/form';
import { CentroCostoSelector } from '../CentroCostoSelector/CentroCostoSelector';
import { SearchCentroCostoRequest } from 'core/centrocosto/models/SearchCentroCostoRequest';
import { Button } from '@orbita-ui/core';
import { useContext, useEffect } from 'react';
import { CostCentresListContext } from 'core/centrocosto/contexts/CostCentreListContext';

interface FilterCostCentreFormValue {
  denominacion: string;
  numeroCuenta: number;
  centroCostoPadreId: number;
}

const mapFormData = (formData: FilterCostCentreFormValue): SearchCentroCostoRequest => {
  return {
    centroCostoPadreId: formData.centroCostoPadreId,
    denominacion: formData.denominacion,
    numeroCuenta: formData.numeroCuenta,
  };
};

const EMPTY_FORM_VALUES = {
  denominacion: '',
  numeroCuenta: null,
  centroCostoPadreId: null,
};

export const FilterCostCentreForm = () => {
  const { searchParams, reloadToken, searchCostCentres } =
    useContext(CostCentresListContext);

  const methods = useForm<FilterCostCentreFormValue>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: EMPTY_FORM_VALUES,
  });

  useEffect(() => {
    if (searchParams) {
      // reseteamos el formulario con los valores que vienen de la URL
      methods.reset({
        denominacion: searchParams.denominacion || '',
        numeroCuenta: searchParams.numeroCuenta || null,
        centroCostoPadreId: searchParams.centroCostoPadreId || null,
      });
    }
  }, [searchParams, methods]);

  const handleSearch = (data: FilterCostCentreFormValue) => {
    searchCostCentres(mapFormData(data));
  };

  return (
    <FormWithValidation
      reactFormHookMethods={methods}
      onSubmit={handleSearch}
      className="m-3"
    >
      <Row>
        <Col>
          <FormWithValidation.TextInput
            name="denominacion"
            label="Denominación"
            placeholder="Denominación del centro de costos"
            fullWidth
          />
        </Col>
        <Col>
          <CuentaSelector
            name="numeroCuenta"
            label="Cuenta"
            filtros={{
              cuentasHuerfanas: false,
              tipoCuenta: 'CENTRO_COSTO',
            }}
            reloadToken={reloadToken}
          />
        </Col>
        <Col>
          <CentroCostoSelector
            name="centroCostoPadreId"
            label="Depende de"
            filtros={{
              cuentasHuerfanas: false,
            }}
            reloadToken={reloadToken}
          />
        </Col>
      </Row>

      <Row className="d-flex justify-content-end">
        <Button
          type="button"
          className="me-2"
          color="destructive"
          variant="outline"
          onClick={() => methods.reset(EMPTY_FORM_VALUES)}
        >
          Limpiar
        </Button>
        <Button className="me-2" color="primary" variant="filled" type="submit">
          Consultar
        </Button>
      </Row>
    </FormWithValidation>
  );
};
